<section class="d-flex flex-column align-items-center text-center generic-spacer">
    <img class="mb-4" style="width: 90px" src="../../../../assets/images/sent-paper-plane.svg" alt="sent paper plane">
    <h1 class="mb-4 font-weight-bold" style="color: #273441; font-size: 28px;">{{'REQUEST_SENT' | translate}}</h1>
    <p style="color: #9aa3ac;">{{'CALL_REQUEST_RECEIVED' | translate}}</p>
    <a class="link" [routerLink]="['/']">{{'RETURN_TO_HOME_PAGE' | translate}}</a>
</section>